import React, { Component } from 'react';
import { Icon, Input, Button } from 'react-materialize';
import { withRouter } from 'react-router';

import StringUtils from '../../utils/StringUtils';
import EventUtils from '../../utils/EventUtils';
import Aggregations from '../aggregations/Aggregations';

import './SearchSidebar.css';

class SearchSidebar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ecm_fulltext: StringUtils.EMPTY,
      queryParams: StringUtils.EMPTY
    }

    this.search = this.search.bind(this);
    this._handleClearClick = this._handleClearClick.bind(this);
    this._handleSearchClick = this._handleSearchClick.bind(this);
    this._handleSearchEnter = this._handleSearchEnter.bind(this);
    this._handleAggregationsChange = this._handleAggregationsChange.bind(this);
    
    if (props.reference) {
      props.reference(this);
    }
  }

  get aggregations() {
    return this._aggregations.aggregations;
  }

  set aggregations(aggregations) {
    this._aggregations.aggregations = aggregations;
  }

  search() {
    EventUtils.raiseEvent('search', this.state, this.props);
  }

  _handleClearClick(event) {
    this.setState({ 
      ecm_fulltext: StringUtils.EMPTY,
      queryParams: StringUtils.EMPTY
    }, () => {
      this._searchBox.state.value = StringUtils.EMPTY;
      document.querySelector('#search-container input').value = StringUtils.EMPTY;
      document.querySelector('#filters').scrollTop=0; // Search side-bar scroll should be top when change jo type
      this._aggregations.clear();
    });
  }

  _handleSearchClick(event) {
    this.setState({ ecm_fulltext: this._searchBox.state.value }, () => {
      this.search();
    });
  }

  _handleSearchEnter(event) {
    if (event.charCode !== 13) {
      return;
    }

    this.setState({ ecm_fulltext: this._searchBox.state.value }, () => {
      this.search();
    });
  }

  _handleAggregationsChange(event) {
    const { fixedFilters, intervalFilters } = event.detail;

    let filters = {};
    Object.assign(filters, fixedFilters);

    filters.queryParams = Object.values(intervalFilters)
      .map((intervalFilter) => {
        const { field, beginDate, endDate } = intervalFilter;

        if (!beginDate && !endDate) {
          return null;
        }

        let querySegments = [];
        if (beginDate) {
          querySegments.push(`${field} > "${beginDate.toISOString()}"`);
        }

        if (endDate) {
          querySegments.push(`${field} < "${endDate.toISOString()}"`);
        }

        return querySegments.join(' AND ').concat(' AND file:content/name IS NOT NULL AND picture:info/colorSpace IS NOT NULL'); 
      })
      .filter(intervalFilter => intervalFilter)
      .join(' AND ');

    this.setState(filters, () => {
      this.search();
    });  
  }

  render() {
    const { ecm_fulltext } = this.state;

    return (
      <aside className="search-sidebar">
        <div id="search-container">
          <div className="content">
            <div id="filters" className="filters loadable">
              <div id="container">
                <Input ref={ (element) => this._searchBox = element } placeholder="Search for something..." s={12} label={`${this.props.jobType} Search`} onKeyPress={ this._handleSearchEnter} defaultValue={ ecm_fulltext } />
                <Aggregations ref={ (element) => this._aggregations = element } onChanged={ this._handleAggregationsChange }></Aggregations>
              </div>
            </div>
            <div className="toolbar">
              <div className="actions">
                <div className="layout horizontal">
                  <Button waves='light' style={{ fontSize: '10px' }} onClick={ this._handleClearClick }>
                    Clear
                    <Icon left>backspace</Icon>
                  </Button>
                  <Button waves='light' style={{ fontSize: '10px' }} onClick={ this._handleSearchClick }>
                    Search
                    <Icon left>search</Icon>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </aside>
    );
  }
}

export default withRouter(SearchSidebar);
